// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#1f5bcc"};